import React, { useState, useEffect } from 'react';
import {
  Package, RefreshCw,
} from 'lucide-react';
import NextDropCard from './NextDropCard';
import RunClubPartnersCard from './RunClubPartnersCard';
import WomensLaunchPostCard from './WomensLaunchPostCard';
import RecoveryCarouselCard from './RecoveryCarouselCard';
import StockAlertsCard from './StockAlertsCard';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PreOrdersTab() {
  const token = sessionStorage.getItem('admin_token');
  const [data, setData] = useState({ interests: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/preorder-interests`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(await res.json());
      } catch (err) { console.error('Fetch pre-order interests failed:', err); }
      finally { setLoading(false); }
    })();
  }, [token]);

  const sizeCounts = {};
  data.interests.forEach(i => { if (i.size_interest) sizeCounts[i.size_interest] = (sizeCounts[i.size_interest] || 0) + 1; });

  return (
    <div className="space-y-6" data-testid="preorders-tab">
      <StockAlertsCard />
      <NextDropCard />
      <WomensLaunchPostCard />
      <RecoveryCarouselCard />
      <RunClubPartnersCard />
      <div>
        <h2 className="text-lg font-bold text-gray-900">Pre-Order Interest</h2>
        <p className="text-sm text-gray-500">HYROX Apparel coming-soon signups</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-xl border border-gray-100 p-4">
          <p className="text-xs text-gray-500 uppercase tracking-wider">Total Signups</p>
          <p className="text-2xl font-bold text-blue-600 mt-1">{data.total}</p>
        </div>
        {Object.entries(sizeCounts).sort().map(([size, count]) => (
          <div key={size} className="bg-white rounded-xl border border-gray-100 p-4">
            <p className="text-xs text-gray-500 uppercase tracking-wider">Size {size}</p>
            <p className="text-2xl font-bold text-gray-900 mt-1">{count}</p>
          </div>
        ))}
      </div>

      {/* eslint-disable-next-line no-nested-ternary -- readable tier picker */}
      {loading ? (
        <div className="text-center py-12"><RefreshCw className="w-5 h-5 text-gray-400 animate-spin mx-auto" /></div>
      ) : data.interests.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-xl">
          <Package className="w-8 h-8 text-gray-300 mx-auto mb-2" />
          <p className="text-gray-400">No pre-order signups yet</p>
          <p className="text-gray-300 text-xs mt-1">Share /coming-soon to start collecting interest</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-100">
              <tr>
                <th className="px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider">Email</th>
                <th className="px-4 py-3 text-center text-[10px] font-bold text-gray-500 uppercase tracking-wider">Size</th>
                <th className="px-4 py-3 text-right text-[10px] font-bold text-gray-500 uppercase tracking-wider">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {data.interests.map((item, i) => (
                <tr key={item.email} className="hover:bg-gray-50" data-testid={`preorder-row-${i}`}>
                  <td className="px-4 py-3 text-sm text-gray-900 font-medium">{item.name || '-'}</td>
                  <td className="px-4 py-3 text-sm text-gray-600">{item.email}</td>
                  <td className="px-4 py-3 text-center">
                    {item.size_interest ? <span className="px-2 py-0.5 text-xs font-bold bg-blue-50 text-blue-600 rounded">{item.size_interest}</span> : '-'}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-400 text-right">{new Date(item.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
